import { getFormEndpoint } from '@/utils/config';
import { composeHttpHeaders } from '../util/httpHeaders';
import { logError } from '@/utils/log';
import { IPageError } from '@/utils/common.types';

interface IFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  preferredContactMethod?: string;
  serialNumber?: string;
  purchaseLocation?: string;
  yearPurchased?: string | number;
  comments?: string;
}

type TFormType = 'contactus' | 'homeowner';

const submitForm = async (
  formType: TFormType,
  formData: Partial<IFormData>
) => {
  const formEndpoint = getFormEndpoint(formType);

  if (!formEndpoint)
    throw new Error(`Form endpoint for "${formType}" not found.`);

  const { url, apiKey } = formEndpoint;

  const headers = {
    ...composeHttpHeaders().headers,
  };

  if (formType === 'homeowner') {
    headers['Api-Key'] = 'f05fcbff-bbb8-41b7-95c3-07e0ef305393';
    headers['ApiKey'] = '4a7838a0-8698-4088-856a-0f327d9f78c4';
  }

  if (formType !== 'homeowner' && apiKey) {
    headers['x-api-key'] = apiKey;
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(formData),
    });

    if (!response?.ok) throw new Error(`Error: ${response?.statusText}`);

    return response;
  } catch (error) {
    const err = error as IPageError;
    logError({
      error: {
        ...err,
        message:
          err.message ||
          `An unexpected error occured submitting form ${formType}`,
      },
    });
  }
};

export const submitFormByType = async (
  formType: TFormType,
  formData: Partial<IFormData>
) => {
  const formFields: Record<string, Partial<IFormData>> = {
    contactus: {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      email: formData?.email,
      phone: formData?.phone,
      comments: formData?.comments,
    },
    homeowner: {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      email: formData?.email,
      phone: formData?.phone,
      preferredContactMethod: formData?.preferredContactMethod,
      serialNumber: formData?.serialNumber,
      purchaseLocation: formData?.purchaseLocation,
      yearPurchased: Number(formData?.yearPurchased),
      comments: formData?.comments?.trim(),
    },
  };

  const formObj = formFields[formType];
  if (!formObj) throw new Error(`Form type "${formType}" not found.`);

  return await submitForm(formType, formObj);
};
